export enum KeyManager {
  Mobile = 'mobile',
  Native = 'native',
  Coinbase = 'coinbase',
  Phantom = 'phantom',
  MetaMask = 'metamask',
  KeepKey = 'keepkey',
  Keplr = 'keplr',
  WalletConnectV2 = 'walletconnectv2',
  Ledger = 'ledger',
  Trezor = 'trezor',
  Vultisig = 'vultisig',
  GridPlus = 'gridplus',
}
